
function moveCTABtn () {
    const eventRelatedBlocks = document.querySelectorAll('.block-event-related');
    eventRelatedBlocks.forEach(block => {
        const buttons = block.querySelector('.wp-block-buttons');
        const mobileCta = block.querySelector('.mobile-cta');
        const clonedButtons = buttons.cloneNode(true);
        mobileCta.appendChild(clonedButtons);
    });
}


const controller = {
	init() {
        moveCTABtn();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
